import {
  TrackUserWithConnections,
  SignInInput,
  ModifyPasswordInput,
  ResetPasswordInput,
  UpdateEmailAddressInput,
  RequestEmailChangeInput,
  GetApiV3SsoSettingsParams as SSOSettingsParams,
  SamlSigninSettingsResult as SamlSigninSettings,
  SignInRedirectInput,
  ProcessEmailChangeInput,
  TwitterCallbackInput,
  GithubCallbackInput,
  RemoveJobConnectionInput,
  UpdateUserInput,
  LinkConnectionInput,
  GetSignUpLinkOutput as SignUpLink,
  Service as ServiceKind,
  GetApiV1SsoSigninRedirectParams as SSOSigninRedirectParams,
  GetApiV1SsoSignupParams as SSOSignupParams,
  SamlCallbackInput,
  CloudinarySignInput,
  CloudinarySignOutput as CloudinarySign,
  AcceptTermsInput,
  GetApiV1TermsParams as TermsParams,
  GetTermsOutput as Terms,
  Service,
  GetApiV1TermsMeParams as TermsMeParams,
  Language,
} from "@givery-technology/track-id-frontend-sdk/generated-sdk/models";

export type {
  SignInInput,
  ModifyPasswordInput,
  ResetPasswordInput,
  UpdateEmailAddressInput,
  RequestEmailChangeInput,
  SSOSettingsParams,
  SamlSigninSettings,
  SignInRedirectInput,
  ProcessEmailChangeInput,
  TwitterCallbackInput,
  GithubCallbackInput,
  RemoveJobConnectionInput,
  UpdateUserInput,
  LinkConnectionInput,
  SignUpLink,
  ServiceKind,
  SSOSigninRedirectParams,
  SSOSignupParams,
  SamlCallbackInput,
  CloudinarySignInput,
  CloudinarySign,
  AcceptTermsInput,
  TermsParams,
  Terms,
  TermsMeParams,
  Language,
};

export { Service };

export const OAuthKind = {
  GITHUB: "github",
  TWITTER: "twitter",
} as const;

export type OAuthKind = (typeof OAuthKind)[keyof typeof OAuthKind];

export type User = TrackUserWithConnections;

/**
 * Get the display name of a service.
 *
 * @param service
 * @returns
 */
export const getServiceName = (service: Service): string => {
  switch (service) {
    case Service.TrackHub:
      return "Track Skill Hub";
    case Service.TrackId:
      return "Track ID";
    case Service.TrackJob:
      return "Track Job";
    case Service.TrackTrain:
      return "Track LMS";
    case Service.TrackWorkforce:
      return "Track Workforce";
    case Service.TrackELearning:
      return "Track e-Learning";
    default:
      return "Unknown Service";
  }
};
